import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// Fetch media files for a conversation
export const fetchMessengerMediaFilesApi = async (conversationId) => {
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_MESSENGER_CONVERSION_DETAILS}?conversationId=${conversationId}`
    );
    return response?.data?.data;
  } catch (error) {
    throw (
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch media files."
    );
  }
};

// Upload a file to messenger
export const uploadFileMessengerApi = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      Endpoints.ADD_MESSENGER_CONVERSION_DETAILS,
      requestPayload
    );
    return response.data;
  } catch (error) {
    throw (
      error?.response?.data?.message ||
      error.message ||
      "Failed to upload file."
    );
  }
};
